export default async function generateResume(prompt, data, JD, user, resumeId) {
  // Construct the JSON payload
  let payload = {
    resume_details: {
      summary: data.personalInfo.summary,
      skills: data.skills,
      projects: data.projects.map((project) => ({
        name: project.name,
        duration: `${project.startDate}-${project.endDate}`,
        description: project.description,
      })),
      internship: [],
      experience: data.experience.map((exp) => ({
        role: exp.title,
        company: exp.company,
        location: exp.location,
        duration: `${exp.startDate}-${exp.endDate}`,
        description: exp.description,
      })),
      achievements: data.achievements,
    },
    job_details: {
      job_description: JD,
    },
    user,
    resumeId,
  };

  try {
    let URL = 'api/generate_resume';
    if (prompt !== null && prompt.length > 0) {
      URL = 'api/generate/custom_prompt';
      payload.prompt = prompt;
    }
    const FINAL_URL = `${process.env.NEXT_PUBLIC_API_URL}/${URL}`;
    console.log('Payload:', payload);
    const response = await fetch(FINAL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${user.token}`
      },
      body: JSON.stringify(payload),
    });
    return response;
  } catch (error) {
    console.error('Error generating resume:', error);
    throw error;
  }
}

export const sendFileToAPI = async (
  file,
  setExtractedResumeData,
  setUserDetails,
  setIsLoading,
  user
) => {
  const formData = new FormData();
  formData.append('file', file);
  const email = user?.email || '';

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/extract_resume`,
      {
        method: 'POST',
        body: formData,
        headers: {
          email: email,
          'Authorization' : `Bearer ${user.token}`
        },
      }
    );

    if (response.ok) {
      setIsLoading(false);
      const data = await response.json();

      setUserDetails(data.extracted_details)
      setExtractedResumeData(data.extracted_details);
      return true;
    } else {
      console.error('Failed to upload file:', response.statusText);
    }
    return false;
  } catch (error) {
    console.error('Error uploading file:', error);
  }
};

export const authorizeUser = async (user) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/auth/authenticate-user`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: user,
      }
    );
    // if (response.ok) {
      return await response.json();
    // } 
  } catch (error) {
    console.error('Error authorizing user:', error);
  }
};

export const findUser = async (email) => {
  try {
    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/find`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }), 
    });

    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.error('Error finding user:', error);
  }
};

export const signIn = async (email, password) => {
  try {
    const expires = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(); 
    // Expires 5 days from now

    const requestBody = JSON.stringify({
      email,
      password,
      provider: "email",
      expires, // 
    });

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/signin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody,
    });

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   console.error("Sign-in failed:", errorData);
    //   throw new Error(`Sign-in failed: ${errorData.message || "Unknown error"}`);
    // }

    return await response.json();
  } catch (error) {
    console.error('Error signing in:', error);
    return null;
  }
};


export const signUp = async (name, email, password) => {
  try {
    const expires = new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString(); 
    // Expires 5 days from now, converted to a string

    const requestBody = JSON.stringify({
      name,
      email,
      password,
      provider: "email",
      expires, // Added expires as a string
    });

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/auth/signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody, 
    });

    // if (!response.ok) {
    //   const errorData = await response.json();
    //   console.error("Signup failed:", errorData);
    //   throw new Error(`Signup failed: ${errorData.message || "Unknown error"}`);
    // }

    return await response.json();
  } catch (error) {
    console.error('Error signing up:', error);
    return null;
  }
};

export const handleProfileUpload = async (formData, user, isProfileUpload, resumeId) => {
  try {
    if (resumeId!=null) {
      formData.append('resumeId', resumeId);
    }
    
    formData.append('isProfileUpload', isProfileUpload);
    
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/upload-profile`,
      {
        method: 'POST',
        body: formData,
        headers: {
          email: user.email,
          'Authorization': `Bearer ${user.token}`
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const getProfileDetails = async (user) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/profile-details`,
      {
        method: 'GET',
        headers: {
          'Authorization' : `Bearer ${user.token}`
        },
      }
    );
    if (response.ok) {
      return await response.json();
    } else if (response.status === 401) {
      return null; 
    }
  } catch (error) {
    console.error('Error authorizing user:', error);
  }
};

export const getCreditDetail = async (user) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/credit`,
      {
        method: 'GET',
        headers: {
          'Authorization' : `Bearer ${user.token}`
        },
      }
    );
    if (response.ok) {
      return await response.json();
    } else if (response.status === 401) {
      return null; 
    }
  } catch (error) {
    console.error('Error', error);
  }
}

export const deductCredit = async (user,credit) => {
    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/api/credit/deduct`,
        {
          method: 'POST',
          headers: {
            'Authorization' : `Bearer ${user.token}`,
            'Content-Type': 'application/json',
          },
          body:JSON.stringify({amount:credit})
        }
      );
      if (response.ok) {
        return await response.json();
      } else if (response.status === 401) {
        return null; 
      }
    } catch (error) {
      console.error('Error', error);
    }
};

export const updateProfileDetails = async (user,profile_details) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/update-profile`,
      {
        method: 'PATCH',
        body: JSON.stringify(profile_details),
        headers: {
          email: user.email,
          'Authorization' : `Bearer ${user.token}`,
          "Content-Type": "application/json", 
        },
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update profile');
    }

    return await response.json();
  } catch (error) {
    console.error('Error:', error);
    // throw error;
  }
};

// app/contact/actions.js
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/api/contact-us`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fullName: formData.fullName,
          email: formData.email,
          phoneNumber: formData.phoneNumber,
          subject: formData.subject,
          message: formData.message,
        }),
      }
    );

    return response;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
}